import { createLogger } from 'common/log'
import { dispatch } from 'common/pageBus'
import { PRODUCT_ADDED_TO_WISHLIST, PRODUCT_REMOVED_FROM_WISHLIST } from 'client/pageBusEvents'

const logger = createLogger('fragments/productDetailsFragmentInfo/AddToWishlistButton')

export const getToastTitle = (inWishlist, t) => t(`wishlist.${inWishlist ? 'removed' : 'added'}`)
export const getWishlistHref = (inWishlist, shortProductCode) =>
  `/wishlist/${inWishlist ? 'remove' : 'add'}?code=${shortProductCode}`

const toastPosition = 'bottom-left'
export const toggleWishlist =
  ({ productDetails, productId, setInWishlist, t, toast }) =>
  async inWishlist => {
    const href = getWishlistHref(inWishlist, productId)
    try {
      const response = await fetch(`${href}&js=true`)
      const res = await response.text()
      const result = JSON.parse(res || '{}')
      if (result.error) {
        throw new Error(t('wishlist.full'))
      }
      setInWishlist(!inWishlist)
      dispatch({
        type: inWishlist ? PRODUCT_REMOVED_FROM_WISHLIST : PRODUCT_ADDED_TO_WISHLIST,
        productDetails
      })
      return toast({ status: 'success', title: getToastTitle(inWishlist, t), position: toastPosition })
    } catch (e) {
      logger.error(`Error on toggling wishlist: ${href}`, e)
      return toast({ status: 'error', title: e.message, position: toastPosition })
    }
  }
